const getSelectedWallIdentifier = (selectedWall: any): string =>
  selectedWall.name.split(' ')[1];

export default getSelectedWallIdentifier;
